import React from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import AdQuarantine from '../../../../../../ReusableFormFields/AdQuarantineField'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'

import { ACTIVE, PAUSED, STATUS } from '../../../../../fields'

const StatusStep = ({ formik }) => {
  const { t } = useTranslation()
  const { values, setFieldValue } = formik

  return (
    <Step stepTitle="Do you want the ad to go live immediately?">
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_status_paused"
        name={STATUS}
        label={t('No, set it as paused')}
        value={PAUSED}
        selectedValue={values[STATUS]}
      >
        <p>{t('Your ad will not go live until you activate it later.')}</p>
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_status_active"
        name={STATUS}
        label={t('Yes, set it as active')}
        value={ACTIVE}
        selectedValue={values[STATUS]}
      >
        <p>{t('Your ad will go live immediately upon ad approval.')}</p>
      </RadioBlock>
      <AdQuarantine formik={formik} />
    </Step>
  )
}

export default StatusStep
